module.exports = __webpack_public_path__ + "media/images/money-c3989af67b643761828fbbdf87c0a64a.png";